<template>
  <div class="tabnav">
    <template v-if="items">
      <div class="tabnav__items">
        <div
          v-for="(item, index) in items"
          :key="`item#${index}`"
          :style="{
            width: contentWidth,
            left: `${index * buttonWidth}px`,
            transform: `translate3d(${index < selectedIndex ? `calc(-100% + ${buttonWidth}px)` : 0 }, 0, 0)`,
            'z-index': count - index,
          }"
          class="tabnav__item"
          :class="{ 'tabnav__item--active': index === selectedIndex }"
        >
          <transition :duration="1000">
            <div
              v-if="index === selectedIndex"
              class="tabnav__content"
            >
              <slot
                name="item"
                :item="item"
                :index="index"
                :active="index === selectedIndex"
              >
                <p>item {{ item.id || 'id inconnu' }}</p>
              </slot>
            </div>
          </transition>

          <TabNavButton
            :label="item.label"
            :theme="item.theme"
            :path="item.path"
            :picto-top="(item.config.intro.preview || [])[0]"
            :picto-bottom="(item.config.intro.preview || [])[1]"
            class="tabnav__link"
            :class="{ 'tabnav__link--active': index === selectedIndex }"
            @click.native="selectedIndex = index"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import TabNavButton from '@/components/navigation/TabNavButton.vue';

export default {
  components: { TabNavButton },

  props: {
    items: { type: Array, default: null },
  },

  data() {
    return {
      selectedIndex: 0,
      buttonWidth: 80,
    };
  },

  computed: {
    count() {
      return this.$props.items ? this.$props.items.length : 0;
    },

    contentWidth() {
      return `calc(100% - ${(this.count - 1) * this.$data.buttonWidth}px)`;
    },
  },

  watch: {
    $route() {
      this.$data.selectedIndex = this.getRouteItemIndex();
    },
  },

  beforeMount() {
    this.$data.selectedIndex = this.getRouteItemIndex();
  },

  methods: {
    getRouteItemIndex() {
      const itemMatch = item => this.$route.path.startsWith(item.path);
      const routeItemIndex = Math.max(0, this.$props.items.findIndex(itemMatch));
      return routeItemIndex;
    },
  },
};
</script>

<style lang="stylus">
.tabnav {
  position: relative;
  overflow: hidden;
}

.tabnav__items {
  width: 100%;
  height: 100%;
}

.tabnav__item {
  display: none;
  top: 0;

  width: 100%;
  height: 100%;
  min-width: 100%;

  transition: transform 0.25s ease-in-out;

  &--active { display: block; }

  +desktop() {
    min-width: 0;
    display: block;
    position: absolute;
  }
}

.tabnav__content {
  width: 100%;
  height: 100%;
}

.tabnav__link {
  display: none;

  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;

  width: 80px;
  height: 100%;

  +desktop() {
    display: block;
  }

  &--active {
    pointer-events: none;
    background-color: transparent;
  }
}
</style>
